import Vue from 'vue'
import axios from 'axios'
import store from '../../store/index'
import router from '../../router/index'

/*
  路由跳转 url 跳转路由地址 string 必须 query 额外参数 object 可选
 */
Vue.prototype.toUrl = function (url, query) {
  if (!url) return false
  const queryParams = {
    ...query
  }
  this.$router.push({
    path: '/admin' + url,
    query: queryParams
  })
}

/*
  url 请求地址 string 必须
  data 请求参数 object 可选
  headers 请求头 默认不需要传值
 */
Vue.prototype.requestApi = function (url, data = {}, headers = '', is_file = false) {
  if (!is_file) {
    var datas = {}
    datas.data = data || {}
  } else {
    datas = data
  }
  // 获取当前路由信息，判断是否传入企业ID，防止用户以站点账号/应用账号分别打开应用下的企业管理，企业下的企业管理标签页
  let currentRoute = router.currentRoute

  // 如果是企业路由，且路由中包含企业ID，且企业ID与当前企业ID不一致，提示用户切换企业
  if (currentRoute.meta.routerType == 2) {
    datas.ins_id = store.state.insInfo.id || 0
  }
  datas.apply_id = store.state.applyInfo.apply_id || store.state.userInfo.applyId || 0

  let header = Object.assign({
    'content-Type': 'application/json;charset=UTF-8',
    'Accept-Language': this.$i18n ? this.$i18n.locale : (localStorage.getItem('language') || 'zh-cn')
  }, headers)
  return new Promise((resolve) => {
    axios.interceptors.request.use(
      config => {
        const token = this.getToken()
        token && (config.headers.Authorization = token)
        return config
      }, error => {
        return Promise.error(error)
      })
    axios({
      method: typeof datas === 'object' ? 'POST' : 'GET',
      url: this.ApiUrl + url,
      data: datas,
      headers: header,
      responseType: 'json',
      withCredentials: true
    }).then(res => {
      if (res.status == 200) {
        if (res.data.status == 4013) {
          this.toUrl('/site/auth_info')
          resolve(res.data)
        } else if (res.data.status == 401) {
          store.dispatch('reomveUserInfo') // 清空用户信息
          store.dispatch('setSubMenu', [])
          this.toUrl('/login')
          this.alertErr(res.data.msg)
        } else if (res.data.status == 402) {
          // 刷新token
          this.requestApi('/adm/refreshToken').then((res) => {
            if (res.status == 1) {
              localStorage.setItem('ACCESS_TOKEN', res.data.token)
              this.requestApi(url, data, headers, is_file).then((res) => {
                resolve(res)
              })
            } else {
              store.dispatch('reomveUserInfo') // 清空用户信息
              store.dispatch('setSubMenu', [])
              this.toUrl('/login')
              this.alertErr(res.msg)
            }
          })
        } else {
          resolve(res.data)
        }
      }
    }).catch(err => {
      this.alertErr('请求失败！', 4.5)
    })
  })
}

/* 获取token */
Vue.prototype.getToken = function () {
  return localStorage.getItem('ACCESS_TOKEN')
}

/* 全局成功消息提醒（多语言） */
Vue.prototype.alertSucc = function (txt, duration = 2) {
  this.$Message.success({
    content: this.$t(txt),
    background: true,
    duration: duration
  })
}

/* 全局错误消息提醒（多语言） */
Vue.prototype.alertErr = function (txt, duration = 2) {
  this.$Message.error({
    content: this.$t(txt),
    background: true,
    duration: duration
  })
}

/* 全局警告消息提醒（多语言） */
Vue.prototype.alertWarn = function (txt, duration = 2) {
  this.$Message.warning({
    content: this.$t(txt),
    background: true,
    duration: duration
  })
}

/* 全局普通消息提醒（多语言） */
Vue.prototype.alertInfo = function (txt, duration = 2, closable = false) {
  this.$Message.info({
    content: this.$t(txt),
    background: true,
    duration: duration,
    closable: closable
  })
}

/* 全局加载中提醒（多语言） */
Vue.prototype.alertLoading = function (txt, duration = 0) {
  this.$Message.loading({
    content: this.$t(txt),
    duration: duration
  })
}

/* 全局销毁消息提醒 */
Vue.prototype.alertDestroy = function () {
  this.$Message.destroy()
}

/* 全局确认弹窗（多语言） */
Vue.prototype.alertConfirm = function ({ title = '', content = '', onOk, onCancel }) {
  this.$Modal.confirm({
    title: this.$t(title),
    content,
    onOk: typeof onOk === 'function' ? onOk : () => {},
    onCancel: typeof onCancel === 'function' ? onCancel : () => {}
  })
}

Vue.prototype.getDateTime = function (date, type = true) {
  date = typeof date !== 'undefined' ? date : new Date()
  var y = date.getFullYear(),
    m = sendDate(date.getMonth() + 1),
    d = date.getDate(),
    h = sendDate(date.getHours()),
    i = sendDate(date.getMinutes()),
    s = sendDate(date.getSeconds())
  if (type) date = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s
  else date = y + '-' + m + '-' + d
  return date
}

// 根据日期计算月份
Vue.prototype.getMonthTime = function (strDate) {
  var date = new Date()
  let Y = date.getFullYear()
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var currentMonth = strDate.substr(5, 2)
  var month = M - currentMonth ? M - currentMonth : 1
  if (month < 0) month = 12 - (currentMonth - M)
  return month
}

// 根据日期计算年龄
Vue.prototype.getAge = function (strBirthday) {
  // strBirthday传入格式 2020-04-15
  var returnAge
  var strBirthdayArr = strBirthday.split('-')
  var birthYear = strBirthdayArr[0]
  var birthMonth = strBirthdayArr[1]
  var birthDay = strBirthdayArr[2]
  // 获取当前日期
  var d = new Date()
  var nowYear = d.getFullYear()
  var nowMonth = d.getMonth() + 1
  var nowDay = d.getDate()
  if (nowYear == birthYear) {
    returnAge = 0 // 同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear // 年之差
    if (ageDiff > 0) {
      if (nowMonth == birthMonth) {
        var dayDiff = nowDay - birthDay // 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      } else {
        var monthDiff = nowMonth - birthMonth // 月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      }
    } else {
      returnAge = -1 // 返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge // 返回周岁年龄
}

Vue.prototype.dateToAge = function (date) {
  // 出生年-月-日
  let Dates = new Date(date)
  // 当前年-月-日
  let now_date = new Date()
  // 生日-年
  let year = Dates.getFullYear()
  // 生日-月
  let month = Dates.getMonth() + 1
  // 当前年份
  let current_year = now_date.getFullYear()
  // 当前月份
  let current_month = now_date.getMonth() + 1
  // 当前年份减去生日年份
  let count_year = current_year - year
  // 当前月份减去生日月份
  let count_month = current_month - month
  if (count_year <= 3) {
    if (count_month < 0) {
      count_year--
      count_month = (current_month + 12) - month
    }
    let age = count_year * 12 + count_month ? count_year * 12 + count_month : 1
    return age + '个月'
  } else {
    if (count_month < 0) {
      count_year--
    }
    return count_year + '岁'
  }
}

function sendDate (d) {
  if (parseInt(d) < 10) {
    d = '0' + d
  }
  return d
}

// 复制文本
Vue.prototype.copyText = function (text) {
  return new Promise((resolve, reject) => {
    let target = document.createElement('input')
    target.value = text
    document.body.appendChild(target)
    target.select()
    try {
      document.execCommand('Copy')
      document.body.removeChild(target)
      resolve(text)
    } catch (e) {
      document.body.removeChild(target)
      reject(e)
    }
  })
}

// 下载图片
Vue.prototype.downloadIamge = function (url, file_name) {
  var image = new Image()
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    var canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    var context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    var url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
    var a = document.createElement('a') // 生成一个a元素
    var event = new MouseEvent('click') // 创建一个单击事件
    a.download = file_name || 'photo' // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = url
}

// 获取完整的图片地址
Vue.prototype.$fullImage = function (img) {
  // 检测传递的图片地址为空
  if (!img) return ''
  var image = img
  if (img.indexOf('http') < 0) {
    image = img.indexOf('/uploads') != -1 || img.indexOf('/image') != -1 ? this.CurrentDomain + img
      : 'https://' +
            img
  }
  return image
}

// 判断当前页面是在哪个端
Vue.prototype.isStoreType = function (type) {
  if (this.$store.state.labelType == type) return true
  else return false
}



// WEBPACK FOOTER //
// ./src/assets/js/comfun.js